import { useId } from "react"

import ChartBg from "@/assets/svg/aura-scan/score-chart-bg.svg?react"

import { cn } from "@/lib/utils"

import { LEVEL_LABEL } from "../config/icons"
import type { SensitivityLevel } from "../types"

const LEVEL_BADGE: Record<SensitivityLevel, string> = {
  low: "bg-peach/20 text-peach",
  moderate: "bg-gold/20 text-gold",
  high: "bg-green/20 text-green",
  "very-high": "bg-green/20 text-green",
}

/** Figma Progress Ring 4061:1321 — viewBox 254×242, stroke 24, starts bottom-left. */
const RING_D =
  "M19.1436 166.9C12.7196 149.534 10.5835 130.875 12.917 112.507C15.2504 94.1388 21.9845 76.6059 32.5467 61.3985C43.1088 46.191 57.1868 33.7587 73.5837 25.1585C89.9807 16.5582 108.212 12.0442 126.727 12.0003C145.243 11.9564 163.495 16.3839 179.933 24.9063C196.37 33.4287 210.507 45.7941 221.141 60.9513C231.775 76.1085 238.593 93.6093 241.013 111.966C243.434 130.323 241.386 148.992 235.044 166.388"

export function SensitivityGauge({
  score,
  level,
}: {
  score: number
  level: SensitivityLevel
}) {
  const gradId = `aura-scan-ring-${useId().replace(/:/g, "")}`
  const pct = Math.max(0, Math.min(100, score))

  return (
    <div className="relative h-[200px] w-[276px] shrink-0 overflow-hidden opacity-80">
      <ChartBg className="absolute inset-0 size-full" />
      <svg
        viewBox="0 0 254 242"
        fill="none"
        className="absolute left-[11px] top-[11px] h-[242px] w-[254px] overflow-visible"
      >
        <defs>
          <linearGradient
            id={gradId}
            x1="19.14"
            y1="166.9"
            x2="235.04"
            y2="166.39"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FF6D4B" />
            <stop offset="0.25" stopColor="#FF9B00" />
            <stop offset="0.5" stopColor="#DED500" />
            <stop offset="0.68" stopColor="#7FE718" />
          </linearGradient>
        </defs>
        <path
          d={RING_D}
          stroke="#DFCBF5"
          strokeOpacity="0.1"
          strokeWidth="24"
          strokeLinecap="round"
        />
        <path
          d={RING_D}
          stroke={`url(#${gradId})`}
          strokeWidth="24"
          strokeLinecap="round"
          pathLength={100}
          strokeDasharray={`${pct} 100`}
        />
      </svg>
      <div className="absolute left-[45px] top-[72px] flex w-[186px] flex-col items-center">
        <p className="font-display text-[56px] font-medium leading-none text-purple-light">
          {pct}%
        </p>
        <span
          className={cn(
            "mt-4 flex h-[41px] w-[144px] items-center justify-center rounded-[24px] font-body text-base font-medium uppercase",
            LEVEL_BADGE[level],
          )}
        >
          {LEVEL_LABEL[level]}
        </span>
      </div>
    </div>
  )
}
